//@ts-nocheck
import posthog from "posthog-js";
import { Organization } from "../types/guide";
const min = 1 / 3;
const mid = 2 / 3;
const max = 3 / 3;

enum CsatFeedback {
	min = 0,
	mid = 1,
	max = 2,
}
let loaded = false;
export type GuideRecordingStarted = {
	eventName: "GuideRecordingStarted";
	value: {};
};
export type GuideRecordingCompleted = {
	eventName: "GuideRecordingCompleted";
	value: {};
};
export type GuideCreated = {
	eventName: "GuideCreated";
	value: { guide_id: string };
};

export type GuideUpdated = {
	eventName: "GuideUpdated";
	value: { guide_id: string };
};
export type GuideEnhanced = {
	eventName: "GuideEnhanced";
	value: { guide_id: string | null };
};

export type GuideOpenedInHelpCenter = {
	eventName: "GuideOpenedInHelpCenter";
	value: {
		guide_id: string;
		organization_id: string;
		source: "embed" | "direct";
	};
};

export type NewButtonClicked = {
	eventName: "NewButtonClicked";
	value: {};
};

export type VideoPlayedInHelpCenter = {
	eventName: "VideoPlayedInHelpCenter";
	value: {
		guide_id: string;
		organization_id: string;
		session_id: string;
		playback_point_in_seconds: number;
		video_duration_in_seconds: number;
		percentage_played: number;
	};
};

export type SearchRunInHelpCenter = {
	eventName: "SearchRunInHelpCenter";
	value: {
		organization_id: string;
		session_id: string;
		search_query: string;
	};
};

export type GuideClickedInSearchResults = {
	eventName: "GuideClickedInSearchResults";
	value: {
		guide_id_clicked: string;
		organization_id: string;
		session_id: string;
	};
};

export type SearchReturnsNoResults = {
	eventName: "SearchReturnsNoResults";
	value: { searchString: string };
};

export type Error = {
	eventName: "UploadError";
	value: { error: string };
};

export type GuideRatedInHelpCenter = {
	eventName: "GuideRatedInHelpCenter";
	value: {
		guide_id: string;
		organization_id: string;
		session_id: string;
		rating: number;
	};
};

export type GuideFeedbackGivenInHelpCenter = {
	eventName: "GuideFeedbackGivenInHelpCenter";
	value: {
		guide_id: string;
		organization_id: string;
		session_id: string;
		feedback: string;
	};
};

export type ScreenshotEditedTextGuide = {
	eventName: "ScreenshotEditedTextGuide";
	value: {
		guide_id: string;
	};
};

export type GifEditedTextGuide = {
	eventName: "GifEditedTextGuide";
	value: {
		guide_id: string;
	};
};

export type ScreenshotAddedInArticleFromVideo = {
	eventName: "ScreenshotAddedInArticleFromVideo";
	value: {
		guide_id: string;
	};
};

export type ScreenshotAddedInTranscriptFromVideo = {
	eventName: "ScreenshotAddedInTranscriptFromVideo";
	value: {
		guide_id: string;
	};
};

export type VideoChunkFailedToUpload = {
	eventName: "VideoChunkFailedToUpload";
	value: {
		guide_id: string;
	};
};

export type CropVideo = {
	eventName: "CropVideo";
	value: {
		guide_id: string;
	};
};

export type CropImage = {
	eventName: "CropImage";
	value: {
		guide_id: string;
	};
};

export type AddTextboxEvent = {
	eventName: "TextboxAdded";
	value: {
		guide_id: string;
	};
};

export type ElementAddedEvent = {
	eventName: "ElementAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ElementDeletedEvent = {
	eventName: "ElementDeleted";
	value: {
		guide_id: string;
		details: any;
		type: any;
	};
};

export type RectangleAddedEvent = {
	eventName: "RectangleAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type RectangleDeletedEvent = {
	eventName: "RectangleDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ZoomAddedEvent = {
	eventName: "ZoomAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ZoomDeletedEvent = {
	eventName: "ZoomDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type BlurAddedEvent = {
	eventName: "BlurAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type BlurDeletedEvent = {
	eventName: "BlurDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ArrowAddedEvent = {
	eventName: "ArrowAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ArrowDeletedEvent = {
	eventName: "ArrowDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type CalloutAddedEvent = {
	eventName: "CalloutAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type CalloutDeletedEvent = {
	eventName: "CalloutDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type SpotlightAddedEvent = {
	eventName: "SpotlightAdded";
	value: {
		guide_id: string;
		details: any;
	};
};

export type SpotlightDeletedEvent = {
	eventName: "SpotlightDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ImageAddedEvent = {
	eventName: "ImageAdded";
	value: {
		guide_id: string;
		details: any;
		type: "upload" | "logo" | "frame";
		flow:
			| "upload-button"
			| "brand-page"
			| "video-frame-selector"
			| "replace-flow";
	};
};

export type LogoUpdatedEvent = {
	eventName: "LogoUpdated";
	value: {
		guide_id: string;
		details: any;
		flow: "footer-popup" | "brand-page";
	};
};

export type ImageDeletedEvent = {
	eventName: "ImageDeleted";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ElementUpdatedEvent = {
	eventName: "ElementUpdated";
	value: {
		guide_id: string;
		details: any;
	};
};

export type PersonalDetailsFilled = {
	eventName: "PersonalDetailsFilled";
	value: {};
};

export type NewProjectClicked = {
	eventName: "NewProjectClicked";
	value: {};
};

export type CaptureScreenRecordingClicked = {
	eventName: "CaptureScreenRecordingClicked";
	value: {};
};

export type UploadVideoClicked = {
	eventName: "UploadVideoClicked";
	value: {};
};

export type UploadPDFClicked = {
	eventName: "UploadPDFClicked";
	value: {};
};

export type UsageLimitExceededErrorShown = {
	eventName: "UsageLimitExceededErrorShown";
	value: UsageLimitExceededErrorBody;
};

export type UpgradePillClicked = {
	eventName: "UpgradePillClicked";
	value: {};
};

export type UpgradeButtonClicked = {
	eventName: "UpgradeButtonClicked";
	value: {};
};

export type HomeVideoPreviewClicked = {
	eventName: "HomeVideoPreviewClicked";
	value: { title: string };
};

export type AddUsersClickedHome = {
	eventName: "AddUsersClickedHome";
	value: {};
};

export type HelpCenterClickedHome = {
	eventName: "HelpCenterClickedHome";
	value: {};
};

export type SaveOrganizationSettings = {
	eventName: "SaveOrganizationSettings";
	value: {
		orgName: string;
		isOpenDoor: boolean;
	};
};

export type ErrorSaveOrganizationSettings = {
	eventName: "ErrorSaveOrganizationSettings";
	value: {
		orgName: string;
		isOpenDoor: boolean;
	};
};

export type InlineAiUiTriggered = {
	eventName: "InlineAiUiTriggered";
	value: {};
};

export type InlineAiTriggered = {
	eventName: "InlineAiTriggered";
	value: {};
};

export type InlineAiReplaced = {
	eventName: "InlineAiReplaced";
	value: {};
};

export type ErrorInlineAiTriggered = {
	eventName: "ErrorInlineAiTriggered";
	value: {};
};

export type GuideAIChatMessageFeedback = {
	eventName: "GuideAIChatMessageFeedback";
	value: {
		guide_id: string;
		message_id: string;
		feedback: string;
	};
};

export type LongVideoSplitterOptionAppeared = {
	eventName: "LongVideoSplitterOptionAppeared";
	value: {};
};

export type LongVideoSplitterSelected = {
	eventName: "LongVideoSplitterSelected";
	value: {};
};

export type ErrorGuideNotFound = {
	eventName: "ErrorGuideNotFound";
	value: {
		guide_id: string;
	};
};

export type ErrorRemirrorInvalidContent = {
	eventName: "ErrorRemirrorInvalidContent";
	value: {
		guide_id: string;
	};
};

export type CustomDomainAddTriggered = {
	eventName: "CustomDomainAddTriggered";
	value: {};
};

export type CustomDomainDeleteTriggered = {
	eventName: "CustomDomainDeleteTriggered";
	value: {
		domain: str;
	};
};

export type CluesoSubdomainChangeTriggered = {
	eventName: "CluesoSubdomainChangeTriggered";
	value: {
		subdomain: str;
	};
};

export type CustomDomainChangeTriggered = {
	eventName: "CustomDomainChangeTriggered";
	value: {
		domain: str;
	};
};

export type CustomDomainVerificationTriggered = {
	eventName: "CustomDomainVerificationTriggered";
	value: {
		domain: str;
	};
};

export type CustomDomainAddOnRequested = {
	eventName: "CustomDomainAddOnRequested";
	value: {};
};

export type LongVideoSplitterAddOnRequested = {
	eventName: "LongVideoSplitterAddOnRequested";
	value: {};
};

export type Error404GuideNotFound = {
	eventName: "Error404GuideNotFound";
	value: {
		guide_id: string;
	};
};

export type AnalyticsFiltersApplied = {
	eventName: "AnalyticsFiltersApplied";
	value: {
		startDate?: string;
		endDate?: string;
		guideId?: string;
	};
};

export type AnalyticsPageOpened = {
	eventName: "AnalyticsPageOpened";
	value: {
		openedThrough: "video" | "direct";
	};
};

export type AnalyticsNoDataFound = {
	eventName: "AnalyticsNoDataFound";
	value: {};
};

export type GuideScrolledInHelpCenter = {
	eventName: "GuideScrolledInHelpCenter";
	value: {
		guide_id: string;
		organization_id: string;
		session_id: string;
		scroll_percentage: number;
	};
};

export type DuplicateGuideFailed = {
	eventName: "DuplicateGuideFailed";
	value: {
		guide_id: string;
	};
};

export type GuideDownloaded = {
	eventName: "GuideDownloaded";
	value: {
		guide_id: string;
	};
};

export type ErrorGuideDownloadCORS = {
	eventName: "ErrorGuideDownloadCORS";
	value: {
		guide_id: string;
	};
};

export type PastExportDownloaded = {
	eventName: "PastExportDownloaded";
	value: {
		export_id: string;
		guide_id: string;
	};
};

export type CaptionsDownloadedSRT = {
	eventName: "CaptionsDownloadedSRT";
	value: {
		guide_id: string;
		source?: "editor" | "export";
	};
};

export type CaptionsDownloadedVTT = {
	eventName: "CaptionsDownloadedVTT";
	value: {
		guide_id: string;
		source?: "editor" | "export";
	};
};

export type LinkCopiedFromExportPage = {
	eventName: "LinkCopiedFromExportPage";
	value: {
		guide_id: string;
	};
};

export type ClickedLastExportLink = {
	eventName: "ClickedLastExportLink";
	value: {
		guide_id: string;
		source: "toast" | "modal";
	};
};

export type FreeToolsPDFtoVideoOpened = {
	eventName: "FreeToolsPDFtoVideoOpened";
	value: {};
};

export type FreeToolsVideoToGIFOpened = {
	eventName: "FreeToolsVideoToGIFOpened";
	value: {};
};

export type CaptionsToggledOnVideo = {
	eventName: "CaptionsToggledOnVideo";
	value: {
		guide_id: string;
		value: boolean;
	};
};

export type CaptionsSizeChanged = {
	eventName: "CaptionsSizeChanged";
	value: {
		guide_id: string;
		size: number;
	};
};
export type CaptionsDownloadedTXT = {
	eventName: "CaptionsDownloadedTXT";
	value: {
		guide_id: string;
	};
};

export type BackgroundUploaded = {
	eventName: "BackgroundUploaded";
	value: {
		guide_id: string;
		background_id: string;
	};
};

export type BackgroundSelected = {
	eventName: "BackgroundSelected";
	value: {
		guide_id: string;
		background_id: string;
		background_type: "image" | "pattern";
	};
};

export type BackgroundDeleted = {
	eventName: "BackgroundDeleted";
	value: {
		guide_id: string;
		background_id: string;
	};
};

export type BackgroundStarred = {
	eventName: "BackgroundStarred";
	value: {
		guide_id: string;
		background_id: string;
		background_type: "image" | "pattern";
	};
};

export type BackgroundUnstarred = {
	eventName: "BackgroundUnstarred";
	value: {
		guide_id: string;
		background_id: string;
	};
};

export type TemplateSelected = {
	eventName: "TemplateSelected";
	value: {
		guide_id: string;
		template_id: string;
		flow: "my-templates" | "library";
		type: "intro" | "outro";
	};
};

export type TemplateCreated = {
	eventName: "TemplateCreated";
	value: {
		guide_id: string;
		template_id: string;
		type: "intro" | "outro";
	};
};

export type TemplateDeleted = {
	eventName: "TemplateDeleted";
	value: {
		guide_id: string;
		template_id: string;
		type: "intro" | "outro";
	};
};

export type SetBackgroundAsDefault = {
	eventName: "SetBackgroundAsDefault";
	value: {
		guide_id: string;
		background_id: string;
	};
};

export type SetTemplateAsDefault = {
	eventName: "SetTemplateAsDefault";
	value: {
		guide_id: string;
		template_id: string;
		type: "intro" | "outro";
		flow: "create-template-flow" | "three-dot-menu-flow";
	};
};

export type MakeFromScratchClickedEvent = {
	eventName: "MakeFromScratchClicked";
	value: {
		guide_id: string;
		type: "intro" | "outro";
	};
};

export type ReplaceButtonOnImageClickedEvent = {
	eventName: "ReplaceButtonOnImageClicked";
	value: {
		guide_id: string;
		details: any;
	};
};

export type ScriptSettingsApplied = {
	eventName: "ScriptSettingsApplied";
	value: {
		script_settings: string;
	};
};

export type VideoSettingsToggleAutoGenerateSpeech = {
	eventName: "VideoSettingsToggleAutoGenerateSpeech";
	value: {
		new_value: boolean;
	};
};

export type VideoSettingsToggleAutoAIWrite = {
	eventName: "VideoSettingsToggleAutoAIWrite";
	value: {
		new_value: boolean;
	};
};

export type VideoSettingsDefaultVoiceAdded = {
	eventName: "VideoSettingsDefaultVoiceAdded";
	value: {
		language: string;
		voice_code: string;
		voice_engine: string;
	};
};

export type VideoSettingsDefaultVoiceEdited = {
	eventName: "VideoSettingsDefaultVoiceEdited";
	value: {
		language: string;
		voice_code: string;
		voice_engine: string;
	};
};

export type VideoSettingsDefaultVoiceDeleted = {
	eventName: "VideoSettingsDefaultVoiceDeleted";
	value: {
		language: string;
	};
};

//#region Music

export type MusicEventData = {
	guide_id: string;
	music_src: string;
	music_name: string;
};

export type MusicVolumeChanged = {
	eventName: "MusicVolumeChanged";
	value: MusicEventData & {
		volume: number;
	};
};

export type MusicAppliedToVideo = {
	eventName: "MusicAppliedToVideo";
	value: MusicEventData;
};

export type MusicRemovedFromVideo = {
	eventName: "MusicRemovedFromVideo";
	value: MusicEventData;
};

export type MusicCategoryTabClicked = {
	eventName: "MusicCategoryTabClicked";
	value: {
		guide_id: string;
		category: string;
	};
};

export type MusicSamplePlayed = {
	eventName: "MusicSamplePlayed";
	value: MusicEventData;
};

export type MusicWaveformClicked = {
	eventName: "MusicWaveformClicked";
	value: MusicEventData & {
		percentage: number;
	};
};

export type MusicOnWaiting = {
	eventName: "MusicOnWaiting";
	value: MusicEventData;
};

export type MusicFavoriteToggled = {
	eventName: "MusicFavoriteToggled";
	value: MusicEventData;
};

export type MusicOnStalled = {
	eventName: "MusicOnStalled";
	value: MusicEventData;
};

// #endregion

export type BorderClicked = {
	eventName: "BorderClicked";
	value: {
		guide_id: string;
		border_type: string;
	};
};

export type ScreenCornerRadiusEdited = {
	eventName: "ScreenCornerRadiusEdited";
	value: {
		guide_id: string;
		source: "toolbar" | "customizer";
		frame: string;
	};
};

export type ScreenShadowEdited = {
	eventName: "ScreenShadowEdited";
	value: {
		guide_id: string;
		source: "toolbar" | "customizer";
		frame: string;
	};
};

export type ScreenBorderColorEdited = {
	eventName: "ScreenBorderColorEdited";
	value: {
		guide_id: string;
		source: "toolbar" | "customizer";
		frame: string;
	};
};

export type ScreenBorderThicknessEdited = {
	eventName: "ScreenBorderThicknessEdited";
	value: {
		guide_id: string;
		source: "toolbar" | "customizer";
		frame: string;
	};
};

export type AnalyticsEvent =
	| GuideOpenedInHelpCenter
	| Error
	| GuideRecordingStarted
	| GuideRecordingCompleted
	| GuideCreated
	| GuideUpdated
	| NewButtonClicked
	| GuideEnhanced
	| SearchRunInHelpCenter
	| SearchReturnsNoResults
	| VideoPlayedInHelpCenter
	| GuideRatedInHelpCenter
	| GuideFeedbackGivenInHelpCenter
	| ScreenshotEditedTextGuide
	| ScreenshotAddedInArticleFromVideo
	| ScreenshotAddedInTranscriptFromVideo
	| VideoChunkFailedToUpload
	| GifEditedTextGuide
	| CropVideo
	| CropImage
	| AddTextboxEvent
	| ElementAddedEvent
	| ElementDeletedEvent
	| RectangleAddedEvent
	| RectangleDeletedEvent
	| ZoomAddedEvent
	| ZoomDeletedEvent
	| BlurAddedEvent
	| BlurDeletedEvent
	| ArrowAddedEvent
	| ArrowDeletedEvent
	| CalloutAddedEvent
	| CalloutDeletedEvent
	| SpotlightAddedEvent
	| SpotlightDeletedEvent
	| ImageAddedEvent
	| LogoUpdatedEvent
	| ImageDeletedEvent
	| ElementUpdatedEvent
	| PersonalDetailsFilled
	| NewProjectClicked
	| CaptureScreenRecordingClicked
	| UploadPDFClicked
	| UploadVideoClicked
	| UsageLimitExceededErrorShown
	| UpgradePillClicked
	| UpgradeButtonClicked
	| HomeVideoPreviewClicked
	| AddUsersClickedHome
	| HelpCenterClickedHome
	| SaveOrganizationSettings
	| ErrorSaveOrganizationSettings
	| InlineAiTriggered
	| InlineAiReplaced
	| InlineAiUiTriggered
	| ErrorInlineAiTriggered
	| GuideAIChatMessageFeedback
	| LongVideoSplitterOptionAppeared
	| LongVideoSplitterSelected
	| ErrorGuideNotFound
	| ErrorRemirrorInvalidContent
	| CluesoSubdomainChangeTriggered
	| CustomDomainAddTriggered
	| CustomDomainDeleteTriggered
	| CustomDomainChangeTriggered
	| CustomDomainVerificationTriggered
	| CustomDomainAddOnRequested
	| Error404GuideNotFound
	| GuideClickedInSearchResults
	| AnalyticsFiltersApplied
	| AnalyticsPageOpened
	| DuplicateGuideFailed
	| GuideScrolledInHelpCenter
	| AnalyticsNoDataFound
	| GuideDownloaded
	| ErrorGuideDownloadCORS
	| PastExportDownloaded
	| CaptionsDownloadedSRT
	| CaptionsDownloadedVTT
	| LinkCopiedFromExportPage
	| ClickedLastExportLink
	| LongVideoSplitterAddOnRequested
	| FreeToolsPDFtoVideoOpened
	| FreeToolsVideoToGIFOpened
	| CaptionsToggledOnVideo
	| CaptionsSizeChanged
	| CaptionsDownloadedTXT
	| BackgroundUploaded
	| BackgroundSelected
	| BackgroundDeleted
	| BackgroundStarred
	| BackgroundUnstarred
	| TemplateCreated
	| TemplateSelected
	| TemplateDeleted
	| SetBackgroundAsDefault
	| SetTemplateAsDefault
	| ScriptSettingsApplied
	| MakeFromScratchClickedEvent
	| ReplaceButtonOnImageClickedEvent
	| VideoSettingsToggleAutoGenerateSpeech
	| VideoSettingsToggleAutoAIWrite
	| VideoSettingsDefaultVoiceAdded
	| VideoSettingsDefaultVoiceEdited
	| VideoSettingsDefaultVoiceDeleted
	| MusicVolumeChanged
	| MusicAppliedToVideo
	| MusicRemovedFromVideo
	| MusicCategoryTabClicked
	| MusicSamplePlayed
	| MusicWaveformClicked
	| MusicOnWaiting
	| MusicOnStalled
	| BorderClicked
	| ScreenCornerRadiusEdited
	| ScreenShadowEdited
	| ScreenBorderColorEdited
	| ScreenBorderThicknessEdited;
export class AnalyticsLogger {
	/**
	 * This class is used for platform.
	 * The standalone functions outside this class are used for the other products.
	 * TODO: Migrate the other products to also use this class later.
	 */

	organization?: Organization;
	email?: string;

	constructor(org?: Organization, email?: string) {
		this.organization = org;
		this.email = email;

		console.log("initializeAnalytics Posthog: ", org);
		try {
			posthog.init("phc_K9xtjpstJIE86BCqAq7SLsbsWK31H7YggUQZIf8xf9x", {
				api_host: "https://app.posthog.com",
				loaded: (posthog) => {
					// posthog.group('company', org.id, {name: org.name})
				},
				autocapture: false,
				capture_pageview: false,
				capture_pageleave: false,
			});

			posthog.group("company", org.id);
			// Identify group once on sign in instead

			if (email) posthog.identify(email);
		} catch (e) {
			try {
				logger.error(e);
				posthog.capture("Error", e);
			} catch (e) {}
		}
	}

	setGuideId = (guideId: string) => {
		this.guideId = guideId;
	};

	captureEvent = (event: AnalyticsEvent) => {
		if (
			process.env.NODE_ENV === "development" ||
			window.location.href.includes("localhost")
		) {
			console.log("Capturing", event);
			return;
		}

		if (!this.email || !this.organization) {
			return;
		}

		try {
			posthog.capture(event.eventName, {
				...event.value,
				$set: {
					email: this.email,
					company: this.organization?.id.toString(),
				},
			});
		} catch (e) {
			console.log("Error", e);
		}
	};
}

export function initializeAnalytics(
	org: Organization | undefined,
	email?: string,
) {
	try {
		posthog.init("phc_K9xtjpstJIE86BCqAq7SLsbsWK31H7YggUQZIf8xf9x", {
			api_host: "https://app.posthog.com",
			loaded: (posthog) => {
				// posthog.group('company', org.id, {name: org.name})
			},
			autocapture: false,
			capture_pageview: false,
			capture_pageleave: false,
		});
		if (org) posthog.group("company", org.id);
		// Identify group once on sign in instead
		if (email) posthog.identify(email);
	} catch (e) {
		try {
			logger.error(e);
			posthog.capture("Error", e);
		} catch (e) {}
	}
}

export function groupName(org: Organization) {
	try {
		posthog.group("company", org.id, { name: org.name });
	} catch (e) {}
}

export function captureEvent(event: AnalyticsEvent) {
	console.log("Capturing", event);
	try {
		posthog.capture(event.eventName, {
			...event.value,
		});
	} catch (e) {}
}

export function loadPostHogDynamically(apiKey, instanceAddress, orgId) {
	// Create a new script element
	if (loaded) {
		return;
	}
	loaded = true;
	const loadPScript = (apiKey, instanceAddress) => {
		const scriptElem = document.createElement("script");

		// Set the content of the script element
		scriptElem.innerHTML = `
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('${apiKey}', {api_host: '${instanceAddress}', autocapture: false,
    capture_pageview: false,
    capture_pageleave: false});
    `;

		// Append the script to the body or head
		document.body.appendChild(scriptElem);
	};
	if (
		!window.location.host.includes("127.0.0.1") &&
		!window.location.host.includes("localhost")
	) {
		loadPScript(apiKey, instanceAddress);
		posthog.init(apiKey, {
			api_host: instanceAddress,
			autocapture: false,
			capture_pageview: false,
			capture_pageleave: false,
		});
		// Try for user
		const user = localStorage.getItem("clueso-helpcenter-user");
		if (user) {
			posthog.identify(user);
		}
	}
}

// Call the function with your API key and instance address
